export enum DndTypes {
  ConstructorItem = "constructorItem",
  IngredientItem = "ingredientItem",
}
